import type * as React from 'react';
import { del } from '@Domain/Api';
import facilityDeleted, {
	type FacilityDeletedAction,
} from '@Application/Facilities/Facilities/Actions/facilityDeleted';
import facilityDeletionFailed, {
	type FacilityDeletionFailedAction,
} from '@Application/Facilities/Facilities/Actions/facilityDeletionFailed';
import type DeleteFacility from '@Application/Facilities/Facilities/Commands/DeleteFacility';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = FacilityDeletedAction | FacilityDeletionFailedAction;

export default (command: DeleteFacility) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await del<void>(
				`${parameters.api.host}/api/organizations/${command.organizationId}/facilities/${command.facilityId}`,
			);

			const action = facilityDeleted({ facilityId: command.facilityId }, command.organizationId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = facilityDeletionFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
